import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import { ChartComponentProps, ColorName, pallet, useDebouncedSize } from './charts';
export type SimpleBarsProps = ChartComponentProps<{
  bars?: BarData[];
  source?: string;
  defaultBarColor?: ColorName;
  width?: string;
}>;
export interface BarData {
  value: number;
  title?: string;
  color?: ColorName;
}
export const SimpleBars = t0 => {
  const $ = _c(25);
  const {
    chart,
    className
  } = t0;
  const {
    bars: t1,
    title,
    source,
    width: t2,
    defaultBarColor
  } = chart;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== className || $[1] !== defaultBarColor || $[2] !== t1 || $[3] !== t2 || $[4] !== title) {
    const bars = t1 === undefined ? [] : t1;
    const width = t2 === undefined ? "20rem" : t2;
    t6 = `py-2 px-5  ${className}`;
    if ($[10] !== title) {
      t7 = title && <h3 className="mb-3 w-[40rem]">{title}</h3>;
      $[10] = title;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    t3 = "flex flex-col gap-4";
    if ($[12] !== width) {
      t4 = {
        width
      };
      $[12] = width;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    t5 = bars?.filter(_temp)?.map((b_0, i) => <Bar key={i} color={b_0.color ?? defaultBarColor ?? "blue"} {...b_0} />);
    $[0] = className;
    $[1] = defaultBarColor;
    $[2] = t1;
    $[3] = t2;
    $[4] = title;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t8 = <div className={t3} style={t4}>{t5}</div>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== source) {
    t9 = source && <div className="mt-3 text-xs italic text-gray-400">{source}</div>;
    $[18] = source;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t6 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t10 = <div className={t6}>{t7}{t8}{t9}</div>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
const Label: FC<{
  x: number;
  y: number;
  children?: React.ReactNode;
  className?: string;
  fill?: string;
}> = p => {
  const $ = _c(6);
  const t0 = `${p.className ?? ""}`;
  let t1;
  if ($[0] !== p.children || $[1] !== p.fill || $[2] !== p.x || $[3] !== p.y || $[4] !== t0) {
    t1 = <text x={p.x} y={p.y} textAnchor="start" alignmentBaseline="central" className={t0} fill={p.fill}>{p.children}</text>;
    $[0] = p.children;
    $[1] = p.fill;
    $[2] = p.x;
    $[3] = p.y;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
const Bar = t0 => {
  const $ = _c(25);
  const {
    title,
    value,
    color,
    className
  } = t0;
  const {
    ref,
    width
  } = useDebouncedSize();
  const barWidth = width * value / 100;
  const labelX = barWidth + 10;
  const colorValue = pallet[color];
  let t1;
  if ($[0] !== title) {
    t1 = title && <p className="mb-1">{title}</p>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== width) {
    t2 = <rect id="bar-bg" width={width} height={40} className="fill-gray-200" />;
    $[2] = width;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== colorValue) {
    t3 = {
      fill: colorValue
    };
    $[4] = colorValue;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== barWidth || $[7] !== t3) {
    t4 = <rect id="bar-value" width={barWidth} height={40} style={t3} />;
    $[6] = barWidth;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== value) {
    t5 = value?.toFixed(0);
    $[9] = value;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = `${t5}%`;
  let t7;
  if ($[11] !== colorValue || $[12] !== labelX || $[13] !== t6) {
    t7 = <Label x={labelX} y={20} fill={colorValue} className="text-lg font-bold">{t6}</Label>;
    $[11] = colorValue;
    $[12] = labelX;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t2 || $[16] !== t4 || $[17] !== t7 || $[18] !== width) {
    t8 = <svg width={width} height={40}>{t2}{t4}{t7}</svg>;
    $[15] = t2;
    $[16] = t4;
    $[17] = t7;
    $[18] = width;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== className || $[21] !== ref || $[22] !== t1 || $[23] !== t8) {
    t9 = <div className={className} ref={ref}>{t1}{t8}</div>;
    $[20] = className;
    $[21] = ref;
    $[22] = t1;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};
function _temp(b) {
  return b != null && b.value != null;
}